var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBarChart = function SvgBarChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "bar-chart_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 21v-2h20v2zm1-3v-7h3v7zm5 0V6h3v12zm5 0V9h3v9zm5 0V3h3v15z"
  })));
};
export { SvgBarChart as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMiAyMVYxOUgyMlYyMUgyWk0zIDE4VjExSDZWMThIM1pNOCAxOFY2SDExVjE4SDhaTTEzIDE4VjlIMTZWMThIMTNaTTE4IDE4VjNIMjFWMThIMThaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";